import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DummyProfile from '../../assets/images/dummy-profile.jpg';
import NoDataIndication from '../TableLoader';
import DataTable from '../JqueryDataTable';
import VerifyModal from './VerifyModal';
import Modal from 'react-bootstrap/Modal';
import { toster_sucess } from '../../helpers/toster_helper';
import { apiHalper } from '../../helpers/ApiHelper';
import { jwtDecode } from '../../helpers/jwt_helper';

import './index.css'

class UnverifiedUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            isLoader: false,
            unverifiedUData: [],
            imageVerify: '',
            isModal: false,
            editData: null,
            isVerifyModal: false,
            verifyMessage: '',
            isDLoader: false,
            page: 1,
            search: '',
            totalRecord: 0,
            sizePerPage: 10,
        }
    }

    componentDidMount() {
        const { page, search, sizePerPage } = this.state;
        this.getUnverifiedUser(page, search, sizePerPage);
    }

    getUnverifiedUser = async (page, search, sizePerPage) => {
        try {
            this.setState({
                isLoader: true,
                unverifiedUData: []
            });

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }
            let formData = new FormData();
            formData.append('page_no', page)
            formData.append('search_by', search)
            formData.append('limit', sizePerPage)

            const response = await apiHalper('getUnverifiedUsers', 'POST', formData, headers)
            const res = response.data;
            if (res.status) {
                const data = jwtDecode(response.data.data);
                this.setState({
                    isLoader: false,
                    unverifiedUData: data.userData,
                    totalRecord: data.count
                });
            }
        } catch (err) {
            console.log(err.message);
        }
    }

    headerSpan = (column, colIndex) => {
        switch (column.dataField) {
            case 'username':
                return <span className={column.sort ? "header_span sort imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'verifications_file':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'status':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            default:
                return <span className={column.sort ? "header_span sort" : "header_span"}>{column.text}</span>;
        }
    }

    handleTableChange = (type, { page, sizePerPage, searchText, sortField, sortOrder, data }) => {
        let result;
        if (sortOrder === 'asc') {
            result = data.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return 1;
                } else if (b[sortField] > a[sortField]) {
                    return -1;
                }
                return 0;
            });
        } else {
            result = data.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return -1;
                } else if (b[sortField] > a[sortField]) {
                    return 1;
                }
                return 0;
            });
        }
        this.setState(() => ({
            data: result
        }))

        if (type === 'pagination') {
            this.setState({
                page,
                sizePerPage
            });
            this.getUnverifiedUser(page, searchText, sizePerPage);
        }

        if (type === 'search') {
            this.setState({
                search: searchText
            });
            this.getUnverifiedUser(page, searchText, sizePerPage);
        }
    }
    imgNotFound = (e) => {
        e.target.src = DummyProfile;
    }
    userName = (cell, row) => {
        const imgfilePath = sessionStorage.getItem('filePath')
        const decodePath = jwtDecode(imgfilePath);
        const imgPath = `${decodePath.img_id}${row.img}`
        return <div className="tb_user_wrap user-prof">
            <div className="useimg_block online_icon">
                <img src={row.img !== null ? imgPath : DummyProfile} onError={(e) => this.imgNotFound(e)} alt="User" />
            </div>
            <p>{row.username}</p>
        </div>
    }
    verification = (cell) => {
        return <span className="text-center margin_0auto">{cell}</span>
    }
    typeFormat = (cell) => {
        return cell
    }
    verificationFile = (cell, row) => {
        const imgfilePath = sessionStorage.getItem('filePath')
        const decodePath = jwtDecode(imgfilePath);
        const imgPath = `${decodePath.img_id}${row.verifications_file}`

        return <div className="tb_user_wrap verification-prof">
            <div className="useimg_block online_icon" onClick={() => this.openImageModal(row)}>
                <img src={row.verifications_file !== null ? imgPath : DummyProfile} onError={(e) => this.imgNotFound(e)} alt="User" />
            </div>
        </div>
    }
    statusField = (cell, row) => {
        if (row.status === '2') {
            return <button type="button" className="btn-status green margin_0auto" disabled>Verified</button>;
        } else {
            return <button type="button" className="btn-status blue margin_0auto" onClick={() => this.openVerifyModal(row)}>Verify</button>;
        }
    }
    openImageModal = (data) => {
        const imgfilePath = sessionStorage.getItem('filePath')
        const decodePath = jwtDecode(imgfilePath);
        const imgPath = `${decodePath.img_id}${data.verifications_file}`
        this.setState({
            isModal: true,
            imageVerify: imgPath !== null ? imgPath : DummyProfile
        })

        console.log(imgPath)
    }
    closeImageModal = () => {
        this.setState({
            isModal: false
        })
    }

    openVerifyModal = (data) => {
        this.setState({
            isVerifyModal: true,
            editData: data
        })
    }

    modalVerifyClose = () => {
        this.setState({
            isVerifyModal: false,
            editData: null
        })
    }
    verifyFunc = async (e) => {
        e.preventDefault();
        try {
            this.setState({
                isDLoader: true
            });

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }

            let formData = new FormData();
            formData.append('profile_id', this.state.editData.profile_id)

            const response = await apiHalper('verifyProfile', 'POST', formData, headers);
            const res = response.data;
            if (res.status) {
                this.setState({
                    isVerifyModal: false,
                    editData: null,
                    verifyMessage: '',
                    isDLoader: false
                });
                
                const { page, search, sizePerPage } = this.state;
                this.getUnverifiedUser(page, search, sizePerPage);
                toster_sucess("Verified Successfully..");
            } else {
                this.setState({
                    isVerifyModal: true,
                    editData: null,
                    verifyMessage: res.message,
                    isDLoader: false
                });
            }

        } catch (err) {
            // console.log(err);
            this.setState({
                verifyMessage: 'Network Error',
                isDLoader: false
            });
        }
    }

    render() {
        const columns = [
            { dataField: 'username', text: 'User Name', sort: true, headerFormatter: this.headerSpan, formatter: this.userName },
            { dataField: 'verifications_file', text: 'Verification File', sort: true, headerFormatter: this.headerSpan, formatter: this.verificationFile },
            { dataField: 'status', text: 'Status', sort: true, headerFormatter: this.headerSpan, formatter: this.statusField }
        ];

        const tableData = {
            columns: columns,
            data: this.state.unverifiedUData,
            keyId: 'profile_verifications_id',
            loading: this.state.isLoader,
            message: 'Table is Empty',
            noDataIndication: <NoDataIndication />,
            page: this.state.page,
            totalRecord: this.state.totalRecord,
            sizePerPage: this.state.sizePerPage,
            handleTableChange: this.handleTableChange,
            isCsv: false,
            dataLimit: [
                { text: '10', value: 10 },
                { text: '20', value: 20 },
                { text: '30', value: 30 },
                { text: '50', value: 50 },
                { text: '100', value: 100 },
                { text: '250', value: 250 },
                { text: '500', value: 500 }
            ]
        };
        const verifyModal = {
            handleClose: this.modalVerifyClose,
            isModal: this.state.isVerifyModal,
            verifyFunc: this.verifyFunc,
            isLoader: this.state.isDLoader
        }

        return (
            <section className="bg-balance">
                <div className="container-fluid">
                    <div className="balance_wrap settings">
                        <DataTable TableData={tableData} />
                        <VerifyModal data={verifyModal} />
                        <Modal show={this.state.isModal} onHide={() => this.closeImageModal()} className="modal_design" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                            <Modal.Body>
                                <div className="modal_view image-view">
                                    <div className="body_modals body_modals2">
                                        <img src={this.state.imageVerify} alt="" />
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </section>
        )
    }
}

export default withRouter(connect(null)(UnverifiedUser))